import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const [isOpenQuienesSomos, setIsOpenQuienesSomos] = useState(false);
  const [isOpenPreguntasFrecuentes, setIsOpenPreguntasFrecuentes] = useState(false);


  return (
    <footer className="bg-ink border-t border-line">

      {/* Enlaces del footer */}
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Mobile Layout - Vertical stacked */}
        <nav className="flex flex-col space-y-4 lg:hidden">
          {/* Navigation Links */}
          <div className="space-y-3">
            <Link to="/" className="block text-base text-white/60 hover:text-white transition-colors">
              {t('footer.links.home')}
            </Link>
            <a 
              href="https://email-tool.easyappforz.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-base text-white/60 hover:text-white transition-colors"
            >
              {t('nav.email_generator')}
            </a>
          </div>

          {/* Company Info */}
          <div className="space-y-3">
            <button 
              onClick={() => setIsOpenQuienesSomos(true)} 
              className="block text-left text-base text-white/60 hover:text-white transition-colors"
            >
              {t('footer.links.about_us')}
            </button>
            <button 
              onClick={() => setIsOpenPreguntasFrecuentes(true)} 
              className="block text-left text-base text-white/60 hover:text-white transition-colors"
            >
              {t('footer.links.faq')}
            </button>
          </div>

          {/* Legal */}
          <div className="space-y-3">
            <Link to="/terms-and-conditions" className="block text-base text-white/60 hover:text-white transition-colors">
              {t('footer.links.terms_conditions')}
            </Link>
            <Link to="/privacy-policy" className="block text-base text-white/60 hover:text-white transition-colors">
              {t('footer.links.privacy_policy')}
            </Link>
          </div>
        </nav>

        {/* Desktop Layout - Horizontal single row */}
        <nav className="hidden lg:flex lg:flex-wrap lg:justify-center lg:gap-8">
          <Link to="/" className="text-base text-white/60 hover:text-white transition-colors">
            {t('footer.links.home')}
          </Link>
          <a 
            href="https://email-tool.easyappforz.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-base text-white/60 hover:text-white transition-colors"
          >
            {t('nav.email_generator')}
          </a>
          <Link to="/terms-and-conditions" className="text-base text-white/60 hover:text-white transition-colors">
            {t('footer.links.terms_conditions')}
          </Link>
          <Link to="/privacy-policy" className="text-base text-white/60 hover:text-white transition-colors">
            {t('footer.links.privacy_policy')}
          </Link>
          <button 
            onClick={() => setIsOpenQuienesSomos(true)} 
            className="text-base text-white/60 hover:text-white transition-colors"
          >
            {t('footer.links.about_us')}
          </button>
          <button 
            onClick={() => setIsOpenPreguntasFrecuentes(true)} 
            className="text-base text-white/60 hover:text-white transition-colors"
          >
            {t('footer.links.faq')}
          </button>
        </nav>
      </div>

      {/* About Us Modal */}
      {isOpenQuienesSomos && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white text-black max-h-[85vh] max-w-2xl w-full overflow-y-auto p-5 sm:p-6 rounded-lg shadow-lg">
            <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.modals.about_us.title')}</h2>
            <p className="text-sm sm:text-base leading-relaxed">
              {t('footer.modals.about_us.content')}
              <br></br><br></br>
              {t('footer.modals.about_us.content2')}
            </p>
            <button className="mt-4 bg-cta hover:bg-cta-hover text-ink font-medium py-2 px-4 rounded-md transition-colors" onClick={() => setIsOpenQuienesSomos(false)}>
              {t('common.close')}
            </button>
          </div>
        </div>
      )}

      {/* FAQ Modal */}
      {isOpenPreguntasFrecuentes && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white text-black max-h-[85vh] max-w-4xl w-full overflow-y-auto p-5 sm:p-8 rounded-lg shadow-lg">
            <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{t('footer.modals.faq.title')}</h2>
            <ul className="list-disc pl-4 sm:pl-5 text-sm sm:text-base">
              {t('footer.modals.faq.questions', { returnObjects: true }).map((faq, index) => (
                <li key={index} className="mb-3 sm:mb-4">
                  <strong>{faq.q}</strong> {faq.a}
                </li>
              ))}
            </ul>
            <button className="mt-4 bg-cta hover:bg-cta-hover text-ink font-medium py-2 px-4 rounded-md transition-colors w-full sm:w-auto" onClick={() => setIsOpenPreguntasFrecuentes(false)}>
              {t('common.close')}
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;